import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';

import Card from '../../components/simple/Card';

import Breadcrumb from '../../components/simple/Breadcrumb';
import ClassDetailCard from '../../components/custom/ClassDetailCard';
import DetailPanels from './DetailPanels';
import ClasseStudents from './ClasseStudents';
import ClasseEvent from './ClasseEvent';

import { getTypeEvidence, getGroupCompleted } from '../../reducers/groups/actions';
import { getCancellation } from '../../reducers/group-cancellation/actions';
import * as Actions from '../Classes/actions';
import './ClasseDetail.scss';

function ClasseDetail(props){
  const { match, classReducer, updateReplacementPolicy, downloadClientReport, groupCancellationReducer } = props;
  const { loading, classDetail, replacementPolicies } = classReducer;
  let { classId, id: groupNID } = match.params
  const history = useHistory();
  const location = useLocation();
  const [previousPathLabel, setPreviousPathLabel] = useState('Calendario de clases');

  const isCancelled = groupCancellationReducer.cancellation?.result?.length > 0;

  const update = () => {
    if(!classDetail || !classDetail.result){
      props.getClass(classId);
      props.getReplacementPolicies();
    }
  }

  useEffect(() => {
    update();
  },[]);

  useEffect(() => {
    if (location.state?.from) {
      const fromPath = location.state.from;
      if (fromPath.includes('/clients/detail/')) {
        setPreviousPathLabel('Lista de grupos');
      } else if (fromPath.includes('/classes')) {
        setPreviousPathLabel('Calendario de clases');
      }
    } else {
      setPreviousPathLabel('Calendario de clases');
    }
  }, [location]);

  useEffect(() => {
    if (classDetail.scheduleDate) {
      const currentClassDate = moment(classDetail.scheduleDate, 'DD-MM-YYYY');
  
      props.getCancellation(groupNID, currentClassDate);
      props.getGroupCompleted(groupNID);
    }
  }, [classDetail]);

  return (
    <div className='ClasseDetail'>
      <div className='ClasseDetail__breadcrumb'>
        <Breadcrumb
          routes={[
            { label: previousPathLabel, onClick: () => history.goBack() },
            { label:'Detalle' }
          ]}
        />
      </div>
      <Row>
        <Col xs={24} sm={24} md={24} lg={19} xl={19} xxl={19}>
          <Col>
            <div className='ClasseDetail__info'>
              <Card>
                <ClassDetailCard
                  { ...props }
                  {...classDetail}
                  groupNID={groupNID}
                  isCancelled={isCancelled}
                  gettingClass={loading.GET_CLASS}
                  replacementPolicies={replacementPolicies}
                  updateReplacementPolicy={updateReplacementPolicy}
                  downloadClientReport={downloadClientReport}
                  refresh={update}
                />
              </Card>
            </div>
          </Col>
          <Col>
            <div className='ClasseDetail__panel'>
              <Card>
                <DetailPanels { ...props }/>
              </Card>
            </div>
          </Col>
        </Col>
        <Col xs={24} sm={24} md={24} lg={5} xl={5} xxl={5}>
          <div className='ClasseDetail__sidebar'>
            <Card>
              <ClasseEvent {...classDetail} isCancelled={isCancelled} />
            </Card>
            <Card>
              <ClasseStudents
                { ...props }
                { ...classDetail }
                update={update}
                loading={loading}
              />
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  );
}


ClasseDetail.propTypes = {};

const mapDispatchToProps = dispatch => bindActionCreators({ ...Actions, getTypeEvidence, getCancellation, getGroupCompleted }, dispatch);
const mapStateToProps = state => ({
  classReducer: state.get('classReducer'),
  groupsReducer: state.get('groupsReducer'),
  groupCancellationReducer: state.get('groupCancellationReducer'),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClasseDetail);

